import React, { useContext, useState, useEffect } from "react";
import { QuestionsContextMemorySpace } from "../../../contexts/questions/questionsContext";
import { NavLink, useLocation } from "react-router-dom";
import "./style.scss";

const MicrositioSidebar = (props) => {
  const { question } = useContext(QuestionsContextMemorySpace);
  const [path, setPath] = useState(true);

  const location = useLocation();

  useEffect(() => {
    if (location.pathname.slice(0, 8) == "/preview") {
      setPath(false);
    }
  }, []);

  return (
    <aside
      className={"asideWebHBMicrositio d-flex justify-content-center scrollable-aside"}
    >
      <div className="d-flex flex-column" style={{ width: "100%" }}>
        <div
          className="d-flex flex-column justify-content-center menuSidebar"
          style={{ width: "100%" }}
        >
          {question.map((item) => (
            <NavLink
              key={item.id}
              className="navigate-button"
              to={path ? `/micrositio/${item.slug}` : `/micrositio/preview/${item.slug}`}
              activeclassname="active"
            >
              <div className="d-flex textoMenuLateral">
                <img
                  src={item?.icono?.url}
                  className="iconosAtencion"
                  alt={item.titulo}
                />{" "}
                <span>{item.titulo}</span>
              </div>
            </NavLink>
          ))}
        </div>
      </div>
    </aside>
  );
};

export default MicrositioSidebar;
